import HasPermission from './HasPermission';
import {
    Redirect,
} from 'react-router-dom';

export default function PermissionsRouteGate({
    children,
    pageName = '',
    scopes = []
}: any) {
    const permissionGranted = HasPermission(pageName, scopes);
    if (!permissionGranted) return <Redirect to='/error/404' />

    return <>{children}</>;
}